import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  mounted() {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          label: "Work Completed",
          backgroundColor: "#f87979",
          data: this.data,
        },
      ],
    });
  },
  computed: {
    labels: function() {
      return this.$store.getters.productivityChartLabels;
    },
    data: function() {
      return this.$store.getters.productivityChartData;
    },
  },
};
